import { createSlice } from '@reduxjs/toolkit';
import { appLs } from '../../utils/localStorage';
import { apiSlice } from '../../app/services/apiSlice';
import { isArray } from 'lodash';

const lsToken = appLs.getObject('token');
const lsAccount = appLs.getObject('account');
const lsRole = appLs.getObject('role');
const lsBasicInformation = appLs.getObject('basic_information');

const AUTH_URL = 'authentication/auth';
export const OAUTH2_REDIRECT_URI = 'http://localhost:3000/profile';
export const GOOGLE_AUTH_URL =
  process.env.REACT_APP_API_URL +
  '/authentication/uaa/oauth2/authorize/google?redirect_uri=' +
  OAUTH2_REDIRECT_URI;

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/login`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    signup: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/signup`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    resetPasswordRequest: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/reset-password-request`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),

    resetPassword: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/reset-password`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    createChat: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/authentication/chat`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    loginWithGoogle: builder.mutation({
      query: () => ({
        url: `${AUTH_URL}/uaa/oauth2/authorize/google?redirect_uri=http://localhost:3000/oauth2/redirect`,
      }),
    }),
  }),
});

const slice = createSlice({
  name: 'auth',
  initialState: {
    token: lsToken,
    account: lsAccount,
    role: lsRole,
    basicInformation: lsBasicInformation,
  },
  reducers: {
    updateCredentials: (state, { payload }) => {
      const shallowCopy = { ...state.account };
      state.account = { ...shallowCopy, ...payload };
      appLs.setObject('account', { ...shallowCopy, ...payload });
      window.$user = { ...shallowCopy, ...payload };
    },
    setCredentials: (state, { payload: { values } }) => {
      state.token = values.accessToken;
      state.account = values.user;
      state.role = (isArray(values.roles) && values?.roles[0]) || {};
      appLs.setObject(
        'role',
        (isArray(values.roles) && values?.roles[0]) || {},
      );
      appLs.setObject('token', values.accessToken);
      appLs.setObject('account', values.user);
      window.$user = values.user;
    },
    setUserBasicInfo: (state, { payload: { values } }) => {
      let lsData = appLs.getObject('basic_information');
      lsData = {
        firstName: values?.firstName || lsData?.firstName || '',
        lastName: values?.lastName || lsData?.lastName || '',
        usingWebHosting:
          values?.usingWebHosting || lsData?.usingWebHosting || false,
        website: values?.website || lsData?.website || '',
        subdomainUrl: values?.subdomainUrl || lsData?.subdomainUrl || '',
        imageUrl:
          values?.imageUrl ||
          lsData?.imageUrl ||
          'https://dev-boostfloral-images.s3.amazonaws.com/userDefault.png',
      };
      state.basicInformation = { ...lsData };
      appLs.setObject('basic_information', { ...lsData });
    },
    removeCredentials: (state) => {
      state.token = undefined;
      state.account = undefined;
      state.role = undefined;
      appLs.removeItem('role');
      appLs.removeItem('token');
      appLs.removeItem('account');
      appLs.removeItem('basic_information');
      localStorage.clear();
    },
  },
});

export const {
  setCredentials,
  updateCredentials,
  removeCredentials,
  setUserBasicInfo,
} = slice.actions;

export default slice.reducer;

export const selectCurrentUser = (state) => state.auth.account;
export const selectBasicInformation = (state) => state.auth.basicInformation;
export const selectUserRole = (state) => state?.auth?.account?.roles[0];

export const {
  useLoginMutation,
  useSignupMutation,
  useResetPasswordRequestMutation,
  useResetPasswordMutation,
  useLoginWithGoogleMutation,
} = extendedApiSlice;
